import { IsOptional, IsString, MaxLength, MinLength } from 'class-validator';

/** Body for POST .../sections/:sectionKey/comment-suggestion — the consultant
 * asks the AI to draft a review comment for a highlighted excerpt. */
export class CommentSuggestionDto {
  @IsString()
  @MinLength(1)
  @MaxLength(500)
  quotedText!: string;

  /** Optional free-text steer, e.g. "troppo informale" / "manca la temperatura". */
  @IsOptional()
  @IsString()
  @MaxLength(500)
  hint?: string;
}
